import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AdminAuthProvider } from "../lib/use-admin-auth";
import { RequireSession } from "../components/auth/RequireSession";
import { RequireAdmin } from "../components/auth/RequireAdmin";
import { AppLayout } from "../components/AppLayout";
import { LoginPage } from "../pages/auth/LoginPage";
import { DashboardPage } from "../pages/app/DashboardPage";
import { AktivitetPage } from "../pages/app/AktivitetPage";
import { OrganisasjonerPage } from "../pages/app/OrganisasjonerPage";
import { OrganizationDetailPage } from "../pages/app/OrganizationDetailPage";
import { BrukereAdminPage } from "../pages/app/BrukereAdminPage";
import { UserDetailPage } from "../pages/app/UserDetailPage";
import { AuksjonerAdminPage } from "../pages/app/AuksjonerAdminPage";
import { AuksjonDetailPage } from "../pages/app/AuksjonDetailPage";
import { OppgaverPage } from "../pages/app/OppgaverPage";
import { OppgaveDetailPage } from "../pages/app/OppgaveDetailPage";
import { StatistikkPage } from "../pages/app/StatistikkPage";
import { InnstillingerPage } from "../pages/app/InnstillingerPage";
import { ProfilPage } from "../pages/app/ProfilPage";
import { VedlikeholdPage } from "../pages/app/VedlikeholdPage";
import { MeldingsmalerPage } from "../pages/app/MeldingsmalerPage";
import { DokumentmalerPage } from "../pages/app/DokumentmalerPage";
import { DokumentmalDetailPage } from "../pages/app/DokumentmalDetailPage";
import { SupportTicketsPage } from "../pages/app/SupportTicketsPage";
import { SupportTicketDetailPage } from "../pages/app/SupportTicketDetailPage";
import { DokumenterPage } from "../pages/app/DokumenterPage";
import { MarketingPage } from "../pages/app/MarketingPage";
import { MarketingResendPage } from "../pages/app/MarketingResendPage";
import { MarketingAiPage } from "../pages/app/MarketingAiPage";
import { RegnskapPage } from "../pages/app/RegnskapPage";
import { RegnskapDetailPage } from "../pages/app/RegnskapDetailPage";
import { SeedBotPage } from "../pages/app/SeedBotPage";
import { AdminOpprettAuksjonPage } from "../pages/app/AdminOpprettAuksjonPage";

export function AppRouter() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <Routes>
          <Route path="/auth/login" element={<LoginPage />} />
          <Route element={<RequireSession />}>
            <Route element={<RequireAdmin />}>
              <Route element={<AppLayout />}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/aktivitet" element={<AktivitetPage />} />
                <Route path="/organisasjoner" element={<OrganisasjonerPage />} />
                <Route path="/organisasjoner/:id" element={<OrganizationDetailPage />} />
                <Route path="/brukere" element={<BrukereAdminPage />} />
                <Route path="/brukere/:id" element={<UserDetailPage />} />
                <Route path="/auksjoner" element={<AuksjonerAdminPage />} />
                <Route path="/auksjoner/opprett" element={<AdminOpprettAuksjonPage />} />
                <Route path="/auksjoner/:id" element={<AuksjonDetailPage />} />
                <Route path="/oppgaver" element={<OppgaverPage />} />
                <Route path="/oppgaver/:id" element={<OppgaveDetailPage />} />
                <Route path="/statistikk" element={<StatistikkPage />} />
                <Route path="/marketing" element={<MarketingAiPage />} />
                <Route path="/marketing/bulk" element={<MarketingPage />} />
                <Route path="/dokumenter" element={< DokumenterPage />} />
                <Route path="/regnskap" element={<RegnskapPage />} />
                <Route path="/regnskap/:accountingdocumentid" element={<RegnskapDetailPage />} />
                <Route path="/innstillinger" element={<InnstillingerPage />} />
                <Route path="/profil" element={<ProfilPage />} />
                <Route path="/profil/:tab" element={<ProfilPage />} />
                <Route path="/support" element={<SupportTicketsPage />} />
                <Route path="/support/:id" element={<SupportTicketDetailPage />} />
                <Route path="/vedlikehold" element={<VedlikeholdPage />} />
                <Route path="/seed-bot" element={<SeedBotPage />} />
                <Route path="/dev/meldingsmaler" element={<MeldingsmalerPage />} />
                <Route path="/dev/dokumentmaler" element={<DokumentmalerPage />} />
                <Route path="/dev/dokumentmaler/:templateKey" element={<DokumentmalDetailPage />} />
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}
